import gql from 'graphql-tag';
import FieldsTimeslotKind from "graphql/fields/FieldsTimeslotKind";

export default gql(`
	query timeslot_kind( $guid: String! ) {
		timeslot_kind( guid: $guid ) {
			${ FieldsTimeslotKind }
		}
	}
`);

